import { useState } from 'react'
import Button from '../../Button'
import { BUTTON_SIZE, BUTTON_TYPE } from '../../Button/Button'
import { useUIComponentsContext } from '../../Provider/UiComponentsProvider'
import { useAccessContext } from '../AccessProvider'
import { AccessAccount } from '../types'
import UserDropdown from './UserDropdown'

interface IAsignAnotherOwner {
  ownerId: string
  onClose: Function
  onOwnerChange?: (newOwner: AccessAccount) => void
}

const AssignAnotherOwner = ({
  ownerId,
  onClose,
  onOwnerChange,
}: IAsignAnotherOwner) => {
  const [selectedUser, setSelectedUser] = useState<AccessAccount | null>(null)

  const { t } = useUIComponentsContext()
  const { ownerUsers, users } = useAccessContext()

  return (
    <div className="bg-white shadow-lg px-4 py-3 rounded-md min-w-[296px]">
      <span className="text-sm text-oxford-gray-800">
        {t?.('expressions.assignAnotherOwner')}
      </span>
      <div className="my-3">
        <UserDropdown
          value={selectedUser}
          onChange={(user) => setSelectedUser(user)}
          dataParser={(data) => data.filter((user) => user.id !== ownerId)}
          placeholder={t?.('expressions.chooseUser')}
          renderClearButton={false}
          data={ownerUsers ? ownerUsers : users}
        />
      </div>

      <div className="flex justify-between">
        <Button
          size={BUTTON_SIZE.SMALL}
          onClick={() => {
            onOwnerChange(selectedUser)
            onClose()
          }}
        >
          {t?.('buttons.assignOwner')}
        </Button>
        <Button
          size={BUTTON_SIZE.SMALL}
          type={BUTTON_TYPE.TEXT}
          onClick={onClose}
        >
          {t?.('buttons.cancel')}
        </Button>
      </div>
    </div>
  )
}

export default AssignAnotherOwner
